import React, { useState, useEffect } from 'react';

function CreateLocationTypeModal({ onClose, onCreate, locationType }) {
  const [formData, setFormData] = useState({
    name: '',
    locations: []
  });

  const [currentLocation, setCurrentLocation] = useState('');

  useEffect(() => {
    if (locationType) {
      setFormData({
        name: locationType.name || '',
        locations: locationType.locations || []
      });
    }
  }, [locationType]);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const addLocation = () => {
    if (!currentLocation.trim()) return;
    
    setFormData({
      ...formData,
      locations: [...formData.locations, currentLocation.trim()]
    });
    
    setCurrentLocation('');
  };

  const removeLocation = (index) => {
    setFormData({
      ...formData,
      locations: formData.locations.filter((_, i) => i !== index)
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name.trim()) return;
    onCreate(formData);
  };

  const handleLocationKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      addLocation();
    }
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <h2>{locationType ? 'Edit Location Type' : 'Create New Location Type'}</h2>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Location Type Name *</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
              placeholder="e.g., Warehouse Sections, Office Rooms, Storage Areas..."
            />
          </div>

          <div className="form-group">
            <label>Available Locations</label>
            
            <div style={{ border: '1px solid #ddd', padding: '1rem', borderRadius: '4px', marginBottom: '1rem' }}>
              <h4>Add Location</h4>
              <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
                <input
                  type="text"
                  placeholder="Location name (e.g., Aisle A1, Room 101, Shelf B2...)"
                  value={currentLocation}
                  onChange={(e) => setCurrentLocation(e.target.value)}
                  onKeyPress={handleLocationKeyPress}
                  style={{ flex: 1 }}
                />
                <button type="button" className="btn" onClick={addLocation}>
                  Add Location
                </button>
              </div>
              <p style={{ fontSize: '0.9rem', color: '#666', margin: 0 }}>
                Press Enter or click "Add Location" to add each location.
              </p>
            </div>

            {formData.locations.length > 0 && (
              <div>
                <h4>Defined Locations ({formData.locations.length})</h4>
                <div style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #ddd', borderRadius: '4px', padding: '0.5rem' }}>
                  {formData.locations.map((location, index) => (
                    <div key={index} style={{ 
                      display: 'flex', 
                      justifyContent: 'space-between', 
                      alignItems: 'center', 
                      padding: '0.5rem',
                      borderBottom: index < formData.locations.length - 1 ? '1px solid #eee' : 'none'
                    }}>
                      <span>{location}</span>
                      <button 
                        type="button" 
                        className="btn btn-danger" 
                        onClick={() => removeLocation(index)}
                        style={{ fontSize: '0.8rem', padding: '0.25rem 0.5rem' }}
                      >
                        Remove
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
            <button type="button" className="btn" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn" disabled={!formData.name.trim()}>
              {locationType ? 'Update Location Type' : 'Create Location Type'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateLocationTypeModal;